import { Dialog, DialogContent, DialogDescription, DialogTitle } from '@/components/ui/dialog'
import { getFormDetail } from '@/lib/data-client/forms'
import { useQuery } from '@tanstack/react-query'
import { FormBuilderClient } from './FormBuilderClient'

interface FormBuilderDialogProps {
  formId: string | null
  open: boolean
  onOpenChange: (open: boolean) => void
}

export function FormBuilderDialog({ formId, open, onOpenChange }: FormBuilderDialogProps) {
  const { data: form, isLoading } = useQuery({
    queryKey: ['form-detail', formId],
    queryFn: () => getFormDetail(formId as string),
    enabled: open && Boolean(formId),
  })

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="left-[10px] top-[10px] h-[calc(100dvh-20px)] max-h-none w-[calc(100dvw-20px)] max-w-none translate-x-0 translate-y-0 overflow-hidden p-0 [&>button]:hidden">
        <DialogTitle className="sr-only">問卷編輯介面</DialogTitle>
        <DialogDescription className="sr-only">
          使用既有問卷 Builder 編輯題目、外觀與邏輯設定。
        </DialogDescription>
        {isLoading || !form ? (
          <div className="grid h-full place-items-center bg-slate-50 text-sm text-slate-500">
            載入問卷編輯器...
          </div>
        ) : (
          <FormBuilderClient initialForm={form} mode="dialog" onClose={() => onOpenChange(false)} />
        )}
      </DialogContent>
    </Dialog>
  )
}
